import {Dispatch, SetStateAction} from 'react';
import {BottomSheet} from 'react-spring-bottom-sheet';
import Button from '../../../../../components/button';
import usePostLoanValidationPayment from '../../../../../services/hookService/postLoanValidationPayment/usePostLoanValidationPayment';

interface IProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  loanGuid: string;
}

const UpgradeAccBtmSheet = ({isOpen, setIsOpen, loanGuid}: IProps) => {
  const {mutate, isLoading} = usePostLoanValidationPayment({
    loan_request: loanGuid,
    onSuccess: data => {
      window.location.href = data;

      setIsOpen(false);
    },
    onError: error => {
      console.error('Payment failed:', error);
    },
  });

  return (
    <BottomSheet
      onDismiss={() => setIsOpen(false)}
      open={isOpen}
      blocking={true}
      className="custom-bottom-sheet"
    >
      <div className="relative flex flex-col w-full gap-2 p-6 CalenderWrapperBottomSheet-wrapper">
        <i
          className="absolute text-2xl text-gray-500 icon-nameClose-remove top-6 left-6"
          onClick={() => setIsOpen(false)}
        />

        <div className="flex flex-col items-center justify-center gap-1">
          <i className="text-4xl text-red-500 icon-nameremove-circle" />
          <p className="flex justify-center text-xl font-medium text-gray-950">
            ارتقا حساب
          </p>
        </div>

        <span className="px-3 text-gray-700 text-md">
          برای دریافت گزارش اعتبارسنجی، حساب کاربری خود را ارتقا دهید یا هزینه
          اعتبارسنجی را پرداخت کنید.
        </span>

        <div className="flex justify-end w-full px-3 mt-1">
          <div className="flex items-center w-full gap-[1rem] mt-2">
            <Button
              onClick={() => mutate()}
              isLoading={isLoading}
              variant="outline"
            >
              پرداخت هزینه
            </Button>
            <Button
              onClick={() =>
                window.location.replace(
                  'https://panel.mazraeapp.com/profile/account',
                )
              }
            >
              ارتقا حساب
            </Button>
          </div>
        </div>
      </div>
    </BottomSheet>
  );
};

export default UpgradeAccBtmSheet;
